<template>
  <NativeVideo
    :id="INTRO_VIDEO.id"
    :sources="sourcesFor(INTRO_VIDEO.name)"
    :poster="INTRO_VIDEO.poster"
    :title="i18n(title)"
    class="mt-8"
    @play="emit('play')"
  />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import NativeVideo from '~/scopes/campaign/components/UI/NativeVideo.vue'
import { useVideoSources } from '~/scopes/campaign/composables/useVideoSources'
import type { I18nDescriptor } from '~/scopes/campaign/data/metals/types'
import { INTRO_VIDEO } from '~/scopes/campaign/data/videos'

defineProps<{ title: I18nDescriptor }>()
const emit = defineEmits<{ play: [] }>()

const i18n = useI18n()
const { sourcesFor } = useVideoSources()
</script>
